<template>
    <el-dialog
        title="图片变量设置"
        v-model="dialogVisible"
        width="1150px" append-to-body class="button-config">
        <el-tabs v-model="navActiveName" tab-position="left" class="detail">
            <el-tab-pane name="second" label="常规">
                <div class="t-o">
                    <div class="t-o-n">类型</div>
                    <el-radio-group v-model="type" @change="upType">
                        <el-radio label="pick">
                            {{ isCustomOpt ? '单选' : '选项' }}
                            <template v-if="type === 'pick' && !isCustomOpt && isAppenControl">
                                <el-checkbox style="margin: 0 10px;" v-model="autoStyle">自动样式</el-checkbox>
                                <el-input-number v-if="autoStyle" v-model="autoStyleNum" :min="1" label="自动样式数量" />
                            </template>
                        </el-radio>
                        <el-radio label="checkbox" v-if="isCustomOpt">多选</el-radio>
                        <el-radio label="star">评星</el-radio>
                    </el-radio-group>
                    <div class="t-o-n" style="padding-left: 30px;">是否必填</div>
                    <el-switch v-model="required" /> 
                    <div class="custom-title" v-if="isCustomOpt">
                        <span class="title">标题</span>
                        <el-input size="small" v-model="customTitle" />
                    </div> 
                    <el-button size="small" type="text" icon="el-icon-circle-plus-outline" class="t-o-new" @click="addPack">新增项</el-button>
                </div>
                <div class="t-table">
                    <div class="t-th">
                        <div class="t-td-0"></div>
                        <div class="t-td-1">内容</div>
                        <div class="t-td-2">默认值</div>
                        <div class="t-td-3">设置内容</div>
                        <div class="t-td-4">操作</div>
                    </div>

                    <el-scrollbar class="t-ts">
                        <draggable
                            element="div"
                            :list="config"
                            :options="{
                                group: { name: 'options', pull: false, put: false },
                                ghostClass: 'ghost',
                                handle: '.t-td-0',
                            }"
                        >
                            <div v-for="(list, ind) in config" :key="ind" class="t-tr">
                                <div class="t-td-0">
                                    <i class="iconfont icon-paixu" />
                                </div>
                                <div class="t-td-1">
                                    <template v-if="type === 'pick' || type === 'checkbox'">
                                        <el-input size="small" v-model="list.name"></el-input>
                                    </template>
                                    <template v-else>
                                        <i v-for="item in config.length" :key="item.i" :class="['iconfont icon-xingxing xing', (ind + 1) >= item ? 'xing-active' : '']" />
                                    </template>
                                </div>
                                <div class="t-td-2">
                                    <!-- <el-radio v-model="defaultVal" :label="list.name" /> -->
                                     <div class="radio-t" :style="isActive(list) ? 'background-color:#4E86FF;border-color:#4E86FF;' : ''" @click="setDefault(list.name)">
                                        <i class="el-icon-check check" />
                                     </div>
                                </div>
                                <div class="t-td-3">
                                    <div class="t-td-3-t">参数</div>
                                    <div class="t-td-3-b" :style="list.parameter && list.parameter.length > 0 ? 'color:#333333;' : ''">
                                        <template v-if="!list.parameter || list.parameter.length === 0">
                                            未设置
                                        </template>
                                        <template v-else>
                                            {{ getName(list) }}
                                        </template>
                                    </div>
                                    <div class="t-td-3-t">条件显示</div>
                                    <div class="t-td-3-b" :style="list.condition && list.condition.linked && list.condition.linked.length > 0 ? 'color:#333333;' : ''">{{ !list.condition || list.condition.linked && list.condition.linked.length === 0 ? '未设置' : '已设置' }}</div>
                                </div>
                                <div class="t-td-4">
                                    <i class="iconfont icon-shezhi" @click="sysL(list, ind)" />
                                    <i class="el-icon-delete-solid" @click="config.splice(ind, 1)" />
                                </div>
                            </div>
                        </draggable>
                    </el-scrollbar>
                </div>
            </el-tab-pane>
        </el-tabs>
        <template v-slot:footer>
            <div class="footer">
                <el-button size="small" @click="close()">取消</el-button>
                <el-button size="small" type="primary" @click="yesSave()">确定</el-button>
            </div>
        </template>
        <sys ref="sysRef" :isCustomOpt="isCustomOpt" :isAppenControl="isAppenControl" @yesSys="yesSys" :allDatas="allDatas" :customData="customData" />
    </el-dialog>
</template>

<script>
import Draggable from "vuedraggable";
import {generateMathRandom} from "@/api/drage";
import { defineAsyncComponent } from "vue";

export default {
    name: 'reviseConfig-index',
    components: {
        Draggable,
        sys: defineAsyncComponent(() => import('./sys'))
    },
    data () {
        return {
            navActiveName: 'second',
            allDatas: [],
            customData: [],
            dialogVisible: false,
            type: 'pick',
            defaultVal: '',
            required: false,
            // parameter 传参 condition 条件
            config: [
                // {
                //     name: '选项1',
                //     i: 1,
                //     parameter: [],
                //     condition: null
                // }
            ],
            upInd: '',
            customTitle: '',
            autoStyle: false,
            autoStyleNum: 1
        }
    },
    props: {
        isAppenControl: {
            type: Boolean,
            default: false
        },
        isCustomOpt: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        getName(list){
            return (list.parameter || []).map(it=>{
                if(it.inputType !== 'variable') return it.value
                else if(it.inputType === 'variable') return it.value && it.value.split('_')[0]
            }).join(',')
            // return (list.parameter || []).map(it => it.value).join(',')
        },
        isActive(list){
          if (this.type === 'checkbox') {
            if (Array.isArray(this.defaultVal)) {
                const idx = this.defaultVal.findIndex(f => f === list.name)
                return idx !== -1
            } else {
                return this.defaultVal === list.name
            }
          } else {
            return this.defaultVal === list.name
          }
        },
        setDefault(val) {
            if (this.type === 'checkbox') {
                // 多选，数据结构变一下
                if (Array.isArray(this.defaultVal)) {
                    const idx = this.defaultVal.findIndex(f => f === val)
                    if (idx === -1) {
                        this.defaultVal.push(val)
                    } else {
                        this.defaultVal.splice(idx, 1)
                    }
                } else {
                    this.defaultVal = val === this.defaultVal ? [val] : []
                }
            } else {
                this.defaultVal = val === this.defaultVal ? '' : val
            }
        },
        upType (val) {
            if (val === 'star') {
                this.config.forEach((it, ind) => {
                    it.name = ind + 1
                })
            }
        },
        yesSave () {
            this.$emit('reviseSave', { type: this.type, config: this.config, defaultVal: this.defaultVal, required: this.required, customTitle: this.customTitle, autoStyleNum: this.autoStyleNum, autoStyle: this.autoStyle })
            this.close()
        },
        close () {
            this.dialogVisible = false
            this.allDatas = []
            this.type = 'pick'
            this.defaultVal = ''
            this.config = []
            this.customData = []
            this.upInd = ''
            this.customTitle = ''
        },
        addPack () {
            const cc = this.config[0] ? JSON.parse(JSON.stringify(this.config[0].parameter)) : []
            const obj = {
                name: this.type === 'pick' ? ('选项' + (this.config.length + 1)) : this.config.length + 1,
                i: generateMathRandom(this.config),
                parameter: cc.map(it => {
                    it.value = ''
                    return it
                }),
                condition: { ov: 'and', isAppen: 'appen', linked: [] }
            }
            this.config.push(obj)
        },
        open (config, allDatas = [], customData = []) {
            console.log('打开', config)
            this.type = config.type
            this.autoStyle = config.autoStyle
            this.autoStyleNum = config.autoStyleNum || 1
            this.config = config.config
            this.customTitle = config.customTitle || ''
            this.defaultVal = config.defaultVal
            this.allDatas = allDatas
            this.customData = customData
            this.required = config.required || false
            this.dialogVisible = true
        },
        sysL (list, ind) {
            console.log('打开设置', list, ind)
            this.upInd = ind
            this.$refs.sysRef.open(JSON.parse(JSON.stringify(list)))
        },
        yesSys (config) {
            if (this.upInd || this.upInd === 0) {
                this.config[this.upInd] = { ...this.config[this.upInd], ...config }
                // 同步其他列的值和个数
                for (let i = 0; i < this.config.length; i++) {
                    if (i !== this.upInd) {
                        const ar = JSON.parse(JSON.stringify(config.parameter)).map(it => {
                            it.value = ''
                            const itind = this.config[i].parameter.findIndex(tt => tt.i === it.i)
                            if (itind !== -1) {
                                it.value = this.config[i].parameter[itind].value
                            }
                            return it
                        })
                        this.config[i].parameter = ar
                    }
                }

                this.upInd = ''
            }
        }
    }
}
</script>

<style scoped lang="scss">
    ::v-deep .button-config {
        border-radius: 4px;
        .el-dialog__header {
            background: #33393E;
            padding: 8px 16px;
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
            .el-dialog__title {
            color: #FFFFFF;
            font-weight: bold;
            font-size: 12px;
            line-height: 20px;
            }
            .el-dialog__headerbtn {
            top: 10px;
            font-size: 16px;
            right: 16px;
            color: #FFFFFF;
            }
        }
        .el-dialog__body {
            padding: 0;
            color: #33393E;
            font-size: 12px;
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
        }
        .el-dialog__footer {
            border-top: 1px solid #F5F7F7;
            padding-bottom: 10px;
        }
    }
    .detail {
        ::v-deep .el-tabs__active-bar {
            left: 0;
            height: 17px !important;
            top: 13px;
            background-color: #4E86FF;
        }
        ::v-deep .el-tabs__item {
            color: #071934;
            font-weight: 400;
            font-size: 14px;
        }
        ::v-deep .el-tabs__nav-wrap.is-left::after {
            width: 1px;
            background-color: #F5F7F7;
        }
        ::v-deep .el-tabs__header {
            height: 500px;
            margin-right: 24px;
        }
        ::v-deep .el-tabs__nav-wrap {
            overflow: auto;
        }
    }

    .xing {
        margin-right: 10px;
        color: #D8D8D8;
        font-size: 16px;
    }
    .xing-active {
        color: #FFD12F;
    }
    .t-o {
        display: flex;
        align-items: center;
        position: relative;
        padding-bottom: 10px;
        padding-top: 11px;
        padding-right: 21px;
        .t-o-n {
            padding-right: 20px;
        }
        .custom-title {
            display: flex;
            align-items: center;
            margin-right: 58px;
            margin-left: auto;
            .title {
                white-space: nowrap;
                margin-right: 10px;
            }
            .el-input {
                width: 460px;
            }
        }
        .t-o-new {
            color: #4E86FF;
            font-weight: 600;
            font-size: 12px;
            i {
                font-size: 16px;
            }
        }
    }
    .t-table {
        padding-right: 20px;
        .t-ts {
            height: 450px;
        }
        .t-th, .t-tr {
            display: flex;
            align-content: center;
        }
        .t-th {
            background-color: #F9FBFF;
            height: 32px;
            line-height: 32px;
            margin-bottom: 6px;
            color: #333333;
            font-weight: 500;
            font-size: 12px;
        }
        .t-tr {
            padding-top: 4px;
            padding-bottom: 4px;
        }
        .t-td-0 {
            font-size: 14px;
            width: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            // i {
            //     margin-left: 5px;
            // }
        }
        .t-td-1 {
            width: 360px;
            text-align: center;
        }
        .t-td-2 {
            width: 122px;
            display: flex;
            align-items: center;
            justify-content: center;
            ::v-deep .el-radio__label {
                display: none;
            }
            .radio-t {
                width: 14px;
                height: 14px;
                border-radius: 2px;
                background-color: #FFFFFF;
                border: 1px solid #DBDFE5;
                position: relative;
                cursor: pointer;
                .check {
                    position: absolute;
                    bottom: 0;
                    right: 2px;
                    color: #fff;
                    font-size: 12px;
                }
            }
        }
        .t-td-3 {
            width: 423px;
            display: flex;
            align-items: center;
            justify-content: center;
            .t-td-3-t {
                color: #333333;
                font-weight: 400;
                font-size: 12px;
                padding-right: 10px;
            }
            .t-td-3-b {
                width: 130px;
                max-width: 130px;
                padding: 5px 12px;
                border-radius: 4px;
                background-color: rgba(241, 240, 240, 0.9);
                margin-right: 18px;
                line-height: 22px;
                color: #999999;
                font-size: 12px;
                min-height: 22px;
                &:last-child {
                    margin-right: 0;
                }
            }
        }
        .t-td-4 {
            width: 111px;
            display: flex;
            align-items: center;
            justify-content: center;
            i {
                cursor: pointer;
                font-size: 16px; 
            }
            .icon-shezhi {
                color: #4ea6ff;
            }
            .el-icon-delete-solid {
                color: red;
                margin-left: 10px;
            }
        }
    }
</style>
